module.exports = __webpack_public_path__ + "img/main_section_img4.98de138b.png";